"use client";
import { Rating } from "react-simple-star-rating";
import { useContext, useRef, useState } from "react";
import { GlobalContext } from "@/context";
import axios from "../../app/lib/axiosInstance";

const GiveYourAvis = ({product}) => {
  const { connected, userData } = useContext(GlobalContext);
  const [rate, setRate] = useState(0);
  const [commentaire, setCommentaire] = useState();
  const [AvisStatus, setAvisStatus] = useState("");

  const text = useRef();
  const CreateOrder = async () => {
    if (connected) {
      if (!rate) {
        setAvisStatus("Assurez-vous de choisir un note.");
      } else if (!commentaire) {
        setAvisStatus("Assurez-vous de laisser un commentaire.");
      } else {
        const data = await axios
          .post(
            "/avis/post",
            {
              productId: product._id,
              rate: rate,
              avis: commentaire,
            },
            { withCredentials: true }
          )
          .then((res) => res.data)
          .then((res) => {
            setAvisStatus("Avis envoyée avec succès.");
            setRate(0);
            setCommentaire("");
          })
          .catch((res) =>
            setAvisStatus(
              "Un problème est survenu, veuillez réessayer plus tard."
            )
          );
      }
    } else {
      setAvisStatus("Assurez-vous de vous connecter d'abord !");
    }
  };
  return (
    <div className="flex flex-col my-8 gap-4 mx-4">
      <h2 className="text-[26px] font-semibold">
        Vous pouvez donner votre avis
      </h2>
      <label className="text-[20px] font-medium">
        Note <span className="text-[#CC0001]">*</span> :
      </label>

      <div className="flex">
        <Rating
          initialValue={rate}
          onClick={(value) => {
            setRate(value);
          }}
          size={36}
          SVGstyle={{ display: "inline" }}
        />
      </div>

      <label className="text-[20px] font-medium">
        Commentaire <span className="text-[#CC0001]">*</span> :
      </label>
      <textarea
        className="w-full md:w-1/2"
        ref={text}
        value={commentaire}
        onChange={() => {
          setCommentaire(text?.current?.value);
        }}
      />
      <h3 className="text-[15px] text-[#CC0001]">{AvisStatus}</h3>
      <button
        className="w-1/4 h-[40px] uppercase text-base bg-[#CC0001] text-[#FFFFFF] rounded-[20px] font-medium"
        onClick={() => {
          CreateOrder();
        }}
      >
        Envoi
      </button>
    </div>
  );
};

export default GiveYourAvis;
